import { createSelector } from 'reselect';
import { goalViewState } from '../../../FinancialPlanGoalDropdown/FinancialPlanGoalDropdownSelector';
import { LIFE } from '../InsuranceConstants';
import { data as dataSelector } from '../../FinancialPlanSelector';
import { selectedIndex as selectedOwnerIndex } from '../OwnerDropdown/OwnerDropdownSelector';

const def = obj => obj || {};
export const isOpen = (state, props) =>
  !!def(def(goalViewState(state, props).subgoals)[props.subgoalId]).isOpen;
export const isLoading = (state, props) =>
  !!def(def(goalViewState(state, props).subgoals)[props.subgoalId]).noteLoading;
export const insuranceName = (state, props) =>
  `${goalViewState(state, props).selectedSection || LIFE} Insurance`;
export const name = (state, props) => props.note.Name;
export const description = (state, props) =>
  def(def(goalViewState(state, props).subgoals)[props.subgoalId]).noteDescription || '';

const NOTES_MISSING_ERROR_MESSAGE = '';

const DEFAULT_PRINCIPAL_NOTES = [
  {
    InsuranceType: 0,
    Notes: [
      {
        Name: 'Needs Analysis',
        Description: NOTES_MISSING_ERROR_MESSAGE,
      },
      {
        Name: 'Income Replacement',
        Description: NOTES_MISSING_ERROR_MESSAGE,
      },
    ],
    IsSpouse: false,
  },
  {
    InsuranceType: 1,
    Notes: [
      {
        Name: 'Level 1',
        Description: NOTES_MISSING_ERROR_MESSAGE,
      },
    ],
    IsSpouse: false,
  },
  {
    InsuranceType: 2,
    Notes: [
      {
        Name: 'Level 1',
        Description: NOTES_MISSING_ERROR_MESSAGE,
      },
    ],
    IsSpouse: false,
  },
  {
    InsuranceType: 3,
    Notes: [],
    IsSpouse: false,
  },
];

export const insuranceNotes = createSelector(
  selectedOwnerIndex,
  dataSelector,
  (state, props) => props.selectedGoal,
  (state, props) => props.goalId,
  (ownerIndex, data, selectedGoal, goalId) => {
    const isPrincipal = ownerIndex === 0;

    const actionSteps = def(data).PlanActionSteps || [];
    let insuranceNotesArray = actionSteps.filter(as => as.GoalId === goalId && as.Type === 12);
    if (isPrincipal) {
      insuranceNotesArray = insuranceNotesArray.filter(note => !note.IsSpouse);
    } else {
      insuranceNotesArray = insuranceNotesArray.filter(note => note.IsSpouse);
    }

    const insuranceTypeMap = {};
    insuranceNotesArray.forEach((note) => {
      if (!insuranceTypeMap[note.InsuranceType]) {
        insuranceTypeMap[note.InsuranceType] = {
          ClientId: null,
          IsSpouse: !isPrincipal,
          InsuranceType: note.InsuranceType,
          Notes: [],
        };
      }
      insuranceTypeMap[note.InsuranceType].Notes.push({
        Name: note.Name,
        Description: note.Text,
      });
    });
    const defaultFallbackNotes = isPrincipal
      ? DEFAULT_PRINCIPAL_NOTES
      : DEFAULT_PRINCIPAL_NOTES.map(note => ({ ...note, IsSpouse: true }));
    return insuranceNotesArray.length > 0
      ? Object.keys(insuranceTypeMap)
        .sort((a, b) => a - b)
        .map(key => insuranceTypeMap[key])
      : defaultFallbackNotes;
  },
);

export const shouldDrawDescriptionLabel = (state, props) =>
  !name(state, props).match(/^Level \d*$/);
